<template>
    <console-content max-width="1440">

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">
                주문목록
                <span>(api)</span>
            </v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>
        
        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-date-field v-model="filter.orderedAt[0]" type="date" clearable label="주문일자" placeholder=" " hide-details></v-date-field>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-date-field v-model="filter.orderedAt[1]" type="date" clearable label="주문일자" placeholder=" " hide-details></v-date-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" class="mt-4">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.status" :items="statuses" item-text="text" item-value="value" label="주문상태" placeholder=" " hide-details/>
                        </v-col>
                    </v-row>
                    <v-row align="center" class="mt-4">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null"/>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true)">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>
        
        <v-row class="mt-6 px-1">
            <v-col cols="auto" class="py-0">
                CP 잔액: {{ cp?.cash?.format?.() }}원
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :items="orders" :headers="ordersHeaders" hide-default-footer disable-sort class="mt-3 mx-1 elevation-1">
            <template v-slot:item.no="{item}">
                {{ (page - 1) * limit + orders.indexOf(item) + 1 }}
            </template>
            <template v-slot:item.giftcard="{item}">
                <v-row v-if="item.giftcard" align="center">
                    <v-col md="auto" class="py-0">
                        <v-img v-if="item.giftcard.thumb" :src="item.giftcard.thumb" contain max-width="96" max-height="96"></v-img>
                        <v-responsive v-else width="96" height="96">
                            <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                <v-icon>mdi-image</v-icon>
                            </v-row>
                        </v-responsive>
                    </v-col>
                    <v-col>
                        <div class="text-start">[{{ item.platform }}]</div>
                        <div class="text-start">{{ item.giftcard.name }}</div>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.sender="{item}">
                <div>{{ item.sender.name }} [{{ item.sender.id }}]</div>
                <div>{{ item.sender.phone.phoneNumberFormat() }}</div>
                <div>{{ item.sender.email }}</div>
            </template>
            <template v-slot:item.faceamt="{item}">
                {{ item?.faceamt?.format?.() }}
            </template>
            <template v-slot:item.quantity="{item}">
                <span>{{ item.quantity }}</span>
                <span style="color:red">{{ displayeQuantity(item) }}</span>
                <!-- {{ item?.quantity?.format?.() }} -->
            </template>
            <template v-slot:item.totalAmount="{item}">
                <!-- <span v-if="item.totalAmount">{{ item?.totalAmount?.format?.() }}</span>
                <span v-else>-</span> -->
                <!-- <span v-else-if="item.salesAmount">{{ (item.salesAmount * (1 + item.commission / 100))?.format?.() }}</span> -->
                <span v-if="item.totalAmount">{{ item?.totalAmount?.format?.() }}</span>
                <span v-else-if="item.salesAmount">{{ (item.salesAmount * (1 + item.commission / 100))?.format?.() }}</span>
                <span style="color:red">{{ displayeTotalAmount(item) }}</span>
            </template>
            <template v-slot:item.orderedAt="{item}">
                {{ $dayjs(item.orderedAt).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template v-slot:item.actions="{item}">
                <v-icon small @click="edit(item)">mdi-pencil</v-icon>
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)" />

        <order-dialog ref="orderDialog" @search="search"></order-dialog>

    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMicrosoftExcel } from "@mdi/js";

import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import VDateField from '@/components/plugins/vuetify/v-date-field.vue';
import orderDialog from "@/components/console/shop/orders/order-dialog.vue"

export default {
    components: {
        ConsoleContent,
        VDateField,
        orderDialog
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                status: this.$route.query.status || null,
                orderedAt: [this.$route.query.orderedAt?.[0] || null, this.$route?.query.orderedAt?.[1] || null],
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "구매자 이름", value: "sender.name" },
                { text: "구매자 아이디", value: "sender.id" },
                { text: "구매자 연락처", value: "sender.phone" },
                { text: "구매자 이메일", value: "sender.email" },
            ],

            cps: [
                { text: ":: 전체 ::", value: null },
            ],

            cp: {},

            statuses: [
                { text: ":: 전체 ::", value: null },
                { text: "주문완료", value: "주문완료"},
                { text: "발권완료", value: "발권완료"},
                { text: "배송처리", value: "배송처리"},
                { text: "배송중", value: "배송중"},
                { text: "배송완료", value: "배송완료"},
                { text: "취소요청", value: "취소요청"},
                { text: "취소불가", value: "취소불가"},
                { text: "취소완료", value: "취소완료"},
                { text: "부분취소완료", value: "부분취소완료"},
                { text: "배송중", value: "배송중"},
                { text: "배송완료", value: "배송완료"},
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            orders: [],
            ordersHeaders: [
                { text: "no", value: "no", align: "center" },
                { text: "주문번호", value: "orderNo", align: "center" },
                { text: "상품권", value: "giftcard", align: "center" },
                { text: "권종", value: "faceamt", align: "center" },
                { text: "수량", value: "quantity", align: "center" },
                { text: "결제금액", value: "totalAmount", align: "center" },
                { text: "발행처", value: "member.name", align: "center" },
				{ text: "구매자", value: "sender", align: "center" },
                { text: "구매일", value: "orderedAt", align: "center" },
                { text: "상태", value: "status", align: "center" },
                { text: "actions", value: "actions", align: "center" },
            ],
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { cps } = await api.console.cps.gets()
            let { cp } = await api.console.cps.get({ _id: this.payload._user })
            this.cp = cp;
            cps.map((cp) => {
                this.cps.push({ text: cp.name, value: cp._id })
            })
            await this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, orders } = await api.console.cps.shop.orders.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.orders = orders;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        open() {
            this.$refs.orderDialog.mode = this.$route.query.mode;
            this.$refs.orderDialog.open();
        },
        edit(order){
            this.$router.push(`/console/cps/shop/orders/${order._id}`);
        },

        async excel(){

            let { orders } = await api.console.cps.shop.orders.gets({
                headers: {
                    limit: 0
                },
                params: this.filter
            });

            var rows = [];
            orders.forEach(order => {
                rows.push({
                    "주문번호": order.orderNo,
                    "상품권": order.giftcard.name,
                    "권종": order.faceamt?.format(),
                    "수량": order.quantity?.format(),
                    "결제금액": (order.totalAmount ?? order.faceamt * order.quantity * (1 + order.commission / 100))?.format(),
                    "구매자 이름": order.sender.name,
                    "구매자 아이디": order.sender.id,
                    "구매자 연락처": order.sender.phone,
                    "구매자 이메일": order.sender.email,
                    "구매일": order.orderedAt ? this.$dayjs(order.orderedAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                    "상태": order.status,
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "new");
            XLSX.writeFile(workbook, "주문목록(api).xlsx");

        },
        displayeQuantity(order){
            let issues = order._issues.filter(el => el.status === "발권완료")
            if(order.quantity !== issues.length) {
                return ` (${issues.length})`
            } else {
                return ""
            }
        },
        displayeTotalAmount(order){
            let issues = order._issues.filter(el => el.status === "발권완료")

            if(order.totalAmount !== issues.length * order.faceamt) {
                return ` (${(issues.length * order.faceamt).format()})`
            } else {
                return ""
            }
        }
    },
    computed: {
        payload(){
            return this.$store.state.payload;
        },
    },
    watch: {
        "$route.query.mode"(){
            this.filter.mode = this.$route.query.mode;
            this.search(false);
        }
    }
}
</script>